import { useAtomValue } from 'jotai';
import { useNavigate } from 'react-router';

import { TagSelection } from '@screens';
import { activeUserIdAtom, activityIdAtom } from '@store';

import { LINKS } from '../utils/routes';

export const TagSelectionScreen = () => {
    const navigate = useNavigate();
    const activeUserId = useAtomValue(activeUserIdAtom);
    const activityId = useAtomValue(activityIdAtom);
    return (
        <TagSelection
            activityId={activityId}
            onClose={() => navigate(LINKS.getFullActivity())}
            activeUserId={activeUserId}
        />
    );
};
